import { defineComponent as m, ref as b, onMounted as C, onUnmounted as w, computed as s, openBlock as f, createElementBlock as v, normalizeClass as k } from "vue";
const r = "https://smartcaptcha.yandexcloud.net/captcha.js", c = 10, S = /* @__PURE__ */ m({
  __name: "SmartCaptcha",
  props: {
    sitekey: {},
    callback: {},
    hl: {},
    test: { type: Boolean },
    webview: { type: Boolean },
    invisible: { type: Boolean },
    shieldPosition: {},
    hideShield: { type: Boolean },
    loadWidget: { type: Boolean, default: !0 },
    timeout: { default: 2e3 },
    onChallengeVisible: {},
    onChallengeHidden: {},
    onNetworkError: {},
    onSuccess: {},
    onTokenExpired: {}
  },
  setup(n) {
    const a = b(), e = n;
    C(() => {
      i.value && d(), p();
    }), w(() => {
      var t;
      i.value && ((t = document.querySelector(`script[src="${r}?render=onload"]`)) == null || t.remove());
    });
    const i = s(() => e.loadWidget), l = s(() => e.invisible === !0), d = () => {
      const t = document.createElement("script");
      t.setAttribute("src", `${r}?render=onload`), t.setAttribute("defer", "true"), document.head.appendChild(t);
    }, p = () => {
      let t = 0;
      const o = setInterval(() => {
        if (++t === c) {
          console.warn(
            `Captcha cannot be initialized for ${e.timeout}ms. Make sure widget script is loaded`
          ), clearInterval(o);
          return;
        }
        if (window.smartCaptcha !== void 0) {
          clearInterval(o);
          const u = window.smartCaptcha.render(a.value, {
            sitekey: e.sitekey,
            callback: e.callback,
            hl: e.hl,
            test: e.test,
            webview: e.webview,
            invisible: e.invisible,
            shieldPosition: e.shieldPosition,
            hideShield: e.hideShield
          });
          h(u);
        }
      }, e.timeout / c);
    }, h = (t) => {
      e.onChallengeHidden && window.smartCaptcha.subscribe(t, "challenge-hidden", e.onChallengeHidden), e.onChallengeVisible && window.smartCaptcha.subscribe(t, "challenge-visible", e.onChallengeVisible), e.onNetworkError && window.smartCaptcha.subscribe(t, "network-error", e.onNetworkError), e.onSuccess && window.smartCaptcha.subscribe(t, "success", e.onSuccess), e.onTokenExpired && window.smartCaptcha.subscribe(t, "token-expired", e.onTokenExpired);
    };
    return (t, o) => (f(), v("div", {
      ref_key: "container",
      ref: a,
      class: k({ "smart-captcha": !l.value })
    }, null, 2));
  }
}), y = {
  install: (n) => {
    n.component("SmartCaptcha", S);
  }
};
export {
  S as SmartCaptcha,
  y as SmartCaptchaPlugin
};
